<button (click)="openAdvancedClaimedTaskTab()" class="ratingReviewerAction btn btn-primary"
        ngbTooltip="{{ 'submission.workflow.generic.' + option + '-help' | translate }}">
  <i class="fa fa-star-half-alt"></i> {{ 'submission.workflow.generic.' + option | translate}}
</button>
